<h1 mat-dialog-title>Estado firma</h1>
<div mat-dialog-content>
  <p *ngIf="response === null">{{error.error.message}}</p>
  <mat-spinner style="margin:0 auto;" *ngIf="show"></mat-spinner>
  <div *ngIf="response != null && !show && !listado">
    <p *ngIf="response.status === 'Cancelada por el cliente'">Cancelada</p>
    <p *ngIf="response.status === 'El proceso de firma ha caducado'">Caducada</p>
    <!--<label class="text-center">{{response.status}}</label>-->
    <br>
    <div *ngIf="response.status === 'Finalizada'" >
      <div *ngFor="let docurl of response.doc; let i = index" class="mb-2">
        <button mat-button  class="aceptar" (click)="getPdf(docurl)"  >
          Descargar {{response.document[i]}}
        </button>
      </div>

    </div>
    <div *ngIf="response === 'Not found'">
      No hay ninguna firma.
    </div>
    <div *ngIf="response !== 'Not found' && response.status != 'Finalizada'" >
        <h6>PENDIENTE</h6> 
        <p>Los documentos están <b>pendientes</b> de firma, <b>puede revisar aquí el correo y el teléfono</b> utilizados para la firma. En el documento de auditoría de firma encontrará más detalles.</p>
        <p>Si el correo al que se mandaron los documentos de firma es incorrecto introduzca el correo correcto y haga click en "Reenviar notificación de firma".</p>
        <p><b>ATENCIÓN: Si se reenvía la firma a un nuevo correo NO se modifica en el expediente</b></p>
        <br>
        <table>
          <thead style="text-align: center;">
            <tr>
              <th>Documento</th>
              <th>Estado</th>
              <th>Histórico</th>
              <th>Cliente</th>
              <th>Email</th>
              <th>Teléfono</th>
              <th>Reenviar Firma</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let document of response.doc; let i = index" style="background-color:#e2e2e2;">
              <td class="celda">{{response.document[i]}}</td>
              <td class="celda">{{response.docstatus[i]}}</td>
              <td class="celda">
                <button mat-button  class="aceptar" (click)="getPdf(document)">
                  <mat-icon>
                    download
                  </mat-icon>
                </button>
              </td>
              <td class="celda">{{response.name[i]}}</td>
              <td class="celda">
                <input type="text" id="email{{i}}" value="{{response.email[i]}}" [disabled]="response.docstatus[i] !== 'PENDIENTE'">
              </td>
              <td class="celda" >{{response.phone[i]}}</td>
              <td class="celda">
                <button mat-button class="aceptar" [disabled]="response.docstatus[i] !=='PENDIENTE'" (click)="reenviarFirma(i, response.setCode, response.key[i])">
                  Reenviar firma
                </button>
                </td>
              </tr>
            </tbody>
          </table>
    </div>
  </div>
  <div *ngIf="response != null && !show && listado">
    <!--<label class="text-center">{{response.status}}</label>-->
    <h6>
      <p *ngIf="estado != 'firmada'">LISTADO ÚLTIMAS 25 FIRMAS PENDIENTES</p>
      <p *ngIf="estado == 'firmada'">LISTADO ÚLTIMAS 25 FIRMAS FINALIZADAS</p>
    </h6>
    <table>
      <thead style="text-align: center;">
        <tr>
          <th>Num. Pedido</th>
          <th>Tipo</th>
          <th>ID</th>
          <th>Documento</th>
          <th>Cliente</th>
          <th>Email</th>
          <th>Teléfono</th>
          <th>Documento Auditoría Firma</th>
        </tr>
      </thead>      
      <tbody>
        <tr *ngFor="let element of response.elements; let i = index" style="background-color:#e2e2e2;">
          <td class="celda">{{element.numPedido}}</td>
          <td class="celda">{{element.tipo}}</td>
          <td class="celda">{{element.idSolicitud}}</td>
          <td class="celda">{{element.document}}</td>
          <td class="celda">{{element.client}}</td>
          <td class="celda">{{element.email}}</td>
          <td class="celda">{{element.phone}}</td>
          <td class="celda">
            <button mat-button  class="aceptar" (click)="getPdf(element.urlAudit)">
              Descargar auditoría
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close="true" id="btn_cerrar">Cerrar</button>
</div>
